import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

export class Ad600CdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin {
	public override readonly models: DeviceModel[] = [DeviceModel.AD600];

	public hideIpConfiguration(): boolean {
		return true;
	}

	public override showPatentInfo(): boolean {
		return true;
	}
}
